export const SORT_OPTIONS = [
  { value: 'desc', label: 'Latest First' },
  { value: 'asc', label: 'Oldest First' },
];

export const RATING_FILTER_OPTIONS = [5, 4, 3, 2, 1];

export const EMPTY_FILTERS = {
  search: '',
  classes: [],
  subjects: [],
  instructors: [],
  rating: '',
};
